// @flow
/* eslint-disable no-unused-vars */
import * as wjcCore from 'wijmo/wijmo';

import { createColumnOrRowFormatter, calculateItemPrice } from '../../../utils';
import type { FormatterArgs } from '../../../types';

const statusFormatter = (args?: FormatterArgs) =>
  createColumnOrRowFormatter({
    columnName: 'Status',
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    formatter: data => {
      const { elem, dataItem, grid } = data;

      if (!dataItem || !dataItem.Price) {
        return;
      }

      if (
        elem.panel === grid.cells &&
        grid.columns[elem.col].binding === 'Total' &&
        dataItem
      ) {
        elem.cell.textContent = wjcCore.Globalize.format(
          calculateItemPrice(dataItem),
          grid.columns[elem.col].format,
        );
      }
    },
  });

export default statusFormatter;
